import { render, staticRenderFns } from "./MaterialProcurementTotalContract.vue?vue&type=template&id=e2a47d30&"
import script from "./MaterialProcurementTotalContract.vue?vue&type=script&lang=js&"
export * from "./MaterialProcurementTotalContract.vue?vue&type=script&lang=js&"
import style0 from "./MaterialProcurementTotalContract.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports